import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-the-h01-grant-criteria-panel",
  "aria-labelledby": "grant-criteria-title"
}
const _hoisted_2 = { class: "p-the-h01-grant-criteria-panel__icon" }
const _hoisted_3 = { class: "p-the-h01-grant-criteria-panel__body" }
const _hoisted_4 = {
  class: "p-the-h01-grant-criteria-panel__name",
  "data-translate-skip": ""
}
const _hoisted_5 = {
  class: "p-the-h01-grant-criteria-panel__point",
  "data-translate-skip": ""
}
const _hoisted_6 = { class: "p-the-h01-grant-criteria-panel__point__body" }
const _hoisted_7 = { class: "p-the-h01-grant-criteria-panel__point__value" }
const _hoisted_8 = { class: "p-the-h01-grant-criteria-panel__point__unit" }
const _hoisted_9 = {
  key: 0,
  class: "p-the-h01-grant-criteria-panel__text",
  "data-translate-skip": ""
}
const _hoisted_10 = { class: "p-the-h01-grant-criteria-panel__footer" }
const _hoisted_11 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconInvestedRounded = _resolveComponent("IconInvestedRounded")!
  const _component_IconArrowRight = _resolveComponent("IconArrowRight")!
  const _component_IconBase = _resolveComponent("IconBase")!

  return (_ctx.isLoaded && _ctx.conditions.length > 0)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _cache[2] || (_cache[2] = _createElementVNode("h2", {
          id: "grant-criteria-title",
          class: "p-the-h01-grant-criteria-panel__title"
        }, " 付与基準例 ", -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.conditions, (condition) => {
          return (_openBlock(), _createElementBlock("div", {
            key: condition.id,
            class: "p-the-h01-grant-criteria-panel__item"
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_IconInvestedRounded, {
                type: _ctx.iconType(condition),
                "icon-size": 36,
                "bg-color": _ctx.colorCode,
                "icon-color": "#ffffff"
              }, null, 8, ["type", "bg-color"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(condition.name), 1),
              _createElementVNode("div", _hoisted_5, [
                _cache[0] || (_cache[0] = _createElementVNode("span", { class: "p-the-h01-grant-criteria-panel__point__sign" }, "+", -1)),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.addComma(condition.points)), 1),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.pointName), 1)
                ])
              ]),
              (condition.text)
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(condition.text), 1))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("a", {
            href: _ctx.urlGrantCriteria,
            class: "p-the-h01-grant-criteria-panel__more"
          }, [
            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "p-the-h01-grant-criteria-panel__more__label" }, " 付与基準をもっと見る ", -1)),
            _createVNode(_component_IconBase, {
              class: "p-the-h01-grant-criteria-panel__more__icon",
              "view-box": "0 0 24 24",
              width: 24,
              height: 24,
              "icon-color": _ctx.colorCode
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconArrowRight)
              ]),
              _: 1
            }, 8, ["icon-color"])
          ], 8, _hoisted_11)
        ])
      ]))
    : _createCommentVNode("", true)
}